module.exports = __webpack_public_path__ + "img/step2-mobile.d1b048de.jpg";